// crmNotificationThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCrmNotificationsApi } from "../../apiservice/crm";

export const loadCrmNotifications = createAsyncThunk(
  "crmNotifications/load",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getCrmNotificationsApi();
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);